import { FC, ReactElement } from "react";

const LockOpen:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path d="M15.8 8h-1.8v-2.4c0-2.897-1.335-4.6-4-4.6s-4 1.703-4 4.6v0.4h2v-0.801c0-1.445 0.797-2.199 2-2.199s2 0.754 2 2.199v2.801h-8c-0.553 0-1 0.646-1 1.199v7.801c0 0.549 0.428 1.139 0.951 1.307l1.197 0.387c0.524 0.167 1.402 0.306 1.952 0.306h5.8c0.549 0 1.428-0.139 1.951-0.307l1.196-0.387c0.524-0.167 0.953-0.757 0.953-1.306v-7.801c0-0.553-0.648-1.199-1.2-1.199z"></path>
        </svg>
    )
}

export default LockOpen;